(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wtm-product-carousel')) {
  customElements.define('wtm-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.life) return;
      this.rail = this.querySelector('.brand-featured-collection__grid');
      this.controls = this.querySelector('.brand-featured-collection__controls');
      if (!this.rail || !this.controls) return;
      this.life = new AbortController();
      const options = {signal:this.life.signal};
      const update = () => {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.controls.hidden = maximum <= 1;
        this.controls.querySelector('[data-carousel-step="-1"]').disabled = this.rail.scrollLeft <= 1;
        this.controls.querySelector('[data-carousel-step="1"]').disabled = this.rail.scrollLeft >= maximum - 1;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-carousel-step]');
        if (!button || !this.contains(button)) return;
        const card = this.rail.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.rail).columnGap) || 0);
        this.rail.scrollBy({left:Number(button.dataset.carouselStep) * step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, options);
      this.rail.addEventListener('scroll', update, {...options,passive:true});
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.rail);
      update();
    }
    disconnectedCallback() {
      this.life?.abort();
      this.resize?.disconnect();
      this.life = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtm-birthstone-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wtm-birthstone-preview')) {
    customElements.define('wtm-birthstone-preview', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }

      disconnectedCallback() {
        this.querySelectorAll('[data-bsp-dialog][open]').forEach(dialog => dialog.close());
        this.controller?.abort();
        this.headerObserver?.disconnect();
        if (this.headerFrame) cancelAnimationFrame(this.headerFrame);
        this.headerFrame = null;
        this.initialized = false;
      }

      initialize() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.variantInput = this.querySelector('[data-bsp-variant]');
        this.submitButton = this.querySelector('[data-bsp-submit]');
        this.submitText = this.querySelector('[data-bsp-submit-text]');
        this.submitPrice = this.querySelector('[data-bsp-submit-price]');
        this.savingBadge = this.querySelector('[data-bsp-saving]');
        this.propertyInputs = { first: this.querySelector('[data-bsp-property="first"]'), second: this.querySelector('[data-bsp-property="second"]') };
        this.status = this.querySelector('[data-bsp-status]');
        this.radios = Array.from(this.querySelectorAll('[data-bsp-option]'));
        this.watchHeader();
        this.bindDialogs();
        this.strings = {};
        this.validCatalog = false;
        try {
          this.config = JSON.parse(this.querySelector('[data-bsp-config]').textContent);
          this.strings = this.config.strings;
          this.palette = this.makePalette(this.config.paletteJson);
          this.overlayUrls = this.readOverlayManifest(this.config.overlayManifestJson);
          this.rasterTokens = { first: 0, second: 0 };
          this.catalog = this.buildCatalog(this.config);
          this.validCatalog = true;
        } catch (_) {
          this.failClosed(this.strings.configurationError || this.status.textContent);
          return;
        }
        const signal = this.controller.signal;
        this.form.addEventListener('change', event => {
          if (!event.target.matches('[data-bsp-option]')) return;
          this.update();
        }, { signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => this.update()), { signal });
        this.form.addEventListener('submit', event => {
          this.update();
          if (!this.validSelection || !this.form.checkValidity()) {
            event.preventDefault();
            this.form.reportValidity();
          }
        }, { capture: true, signal });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          this.restoreVariant(id);
          this.update();
        }, { signal });
        window.addEventListener('pageshow', () => this.update(), { signal });
        this.radios.forEach(radio => {
          const color = this.colorFor(radio.value);
          if (color) radio.nextElementSibling.querySelector('.wtm-bsp__gem').style.setProperty('--bsp-stone', color);
        });
        this.configurePreview();
        const initialId = new URL(window.location.href).searchParams.get('variant') || this.config.initialVariantId;
        this.restoreVariant(initialId);
        this.update();
      }

      makePalette(raw) {
        const palette = {
          january: '#8d1736', february: '#8240af', march: '#48c2e8', april: '#eef4fa',
          may: '#168b49', june: '#bd8ee0', july: '#cc2545', august: '#9dcb3b',
          september: '#1d3dba', october: '#e5a1c4', november: '#e4b935', december: '#636bd7'
        };
        if (raw?.trim()) {
          const overrides = JSON.parse(raw);
          Object.entries(overrides).forEach(([month, hex]) => {
            if (!(month.toLowerCase() in palette) || !/^#[0-9a-f]{6}$/i.test(hex)) throw new Error('Invalid preview palette');
            palette[month.toLowerCase()] = hex;
          });
        }
        return palette;
      }

      bindDialogs() {
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-bsp-dialog-open]').forEach(button => {
          const dialog = this.querySelector(`[data-bsp-dialog="${button.dataset.bspDialogOpen}"]`);
          if (!dialog) return;
          button.addEventListener('click', () => {
            if (dialog.open) return;
            dialog.showModal();
            button.setAttribute('aria-expanded', 'true');
          }, options);
          dialog.addEventListener('close', () => button.setAttribute('aria-expanded', 'false'), options);
        });
        this.querySelectorAll('[data-bsp-dialog-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close(), options));
        this.querySelectorAll('[data-bsp-dialog]').forEach(dialog => {
          const outside = event => {
            const bounds = dialog.getBoundingClientRect();
            return event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
          };
          let backdropPress = false;
          dialog.addEventListener('pointerdown', event => { backdropPress = outside(event); }, options);
          dialog.addEventListener('click', event => { if (backdropPress && outside(event)) dialog.close(); backdropPress = false; }, options);
        });
      }

      syncProperties(first = '', second = '') {
        ['first', 'second'].forEach((side, index) => {
          const input = this.propertyInputs?.[side];
          if (!input) return;
          const value = index === 0 ? first : second;
          input.value = value;
          input.disabled = !value;
        });
      }

      watchHeader() {
        const headers = Array.from(document.querySelectorAll('wtm-site-header, .wtm-header'));
        this.headerElements = Array.from(new Set(headers.flatMap(header => [header, header.closest('.shopify-section, [id^="shopify-section-"]')]).filter(Boolean)));
        const measure = () => {
          this.headerFrame = null;
          let offset = this.headerElements.length ? 0 : 57;
          this.headerElements.forEach(header => {
            const bounds = header.getBoundingClientRect();
            const style = getComputedStyle(header);
            if (bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 && bounds.top < window.innerHeight && style.visibility !== 'hidden' && style.display !== 'none') offset = Math.max(offset, Math.min(bounds.bottom, window.innerHeight));
          });
          this.style.setProperty('--bsp-header-offset', `${Math.ceil(offset)}px`);
        };
        const schedule = () => {
          if (!this.headerFrame) this.headerFrame = requestAnimationFrame(measure);
        };
        measure();
        if ('ResizeObserver' in window) {
          this.headerObserver = new ResizeObserver(schedule);
          this.headerElements.forEach(header => this.headerObserver.observe(header));
        }
        window.addEventListener('resize', schedule, { passive: true, signal: this.controller.signal });
        window.addEventListener('scroll', schedule, { passive: true, signal: this.controller.signal });
      }

      colorFor(value) {
        const month = this.monthFor(value);
        return this.palette[month] || null;
      }

      monthFor(value) {
        return String(value).trim().toLowerCase().match(/^[a-z]+/)?.[0] || '';
      }

      readOverlayManifest(raw) {
        const result = { first: {}, second: {} };
        if (!raw?.trim()) return result;
        try {
          const manifest = JSON.parse(raw);
          ['first', 'second'].forEach(side => {
            Object.entries(manifest[side] || {}).forEach(([month, value]) => {
              const url = new URL(value, window.location.origin);
              if (month.toLowerCase() in this.palette && url.protocol === 'https:') result[side][month.toLowerCase()] = url.href;
            });
          });
        } catch (_) {}
        return result;
      }

      buildCatalog(config) {
        if (!Array.isArray(config.optionNames) || config.optionNames.length !== 2 || !Array.isArray(config.variants)) throw new Error('Invalid options');
        this.firstIndex = config.optionNames.indexOf(config.firstOptionName);
        this.secondIndex = config.optionNames.indexOf(config.secondOptionName);
        if (this.firstIndex < 0 || this.secondIndex < 0 || this.firstIndex === this.secondIndex) throw new Error('Missing birthstone options');
        const first = this.radios.filter(radio => radio.dataset.bspOption === 'first').map(radio => radio.value);
        const second = this.radios.filter(radio => radio.dataset.bspOption === 'second').map(radio => radio.value);
        if (first.length !== 12 || second.length !== 12 || new Set(first).size !== 12 || new Set(second).size !== 12) throw new Error('Incomplete birthstone options');
        if (config.variantCount !== 144 || config.variants.length !== 144) throw new Error('Incomplete variant catalog');
        const map = new Map();
        const ids = new Set();
        config.variants.forEach(variant => {
          if (!variant.id || !Array.isArray(variant.options) || variant.options.length !== 2) throw new Error('Invalid variant');
          const a = variant.options[this.firstIndex];
          const b = variant.options[this.secondIndex];
          const key = JSON.stringify([a, b]);
          if (!first.includes(a) || !second.includes(b) || map.has(key) || ids.has(String(variant.id)) || !config.prices[String(variant.id)]?.price) throw new Error('Ambiguous variant');
          map.set(key, variant);
          ids.add(String(variant.id));
        });
        first.forEach(a => second.forEach(b => { if (!map.has(JSON.stringify([a, b]))) throw new Error('Missing combination'); }));
        return map;
      }

      restoreVariant(id) {
        this.radios.forEach(radio => { radio.checked = false; });
        if (!id) return;
        const variant = this.config.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        this.radios.forEach(radio => {
          const index = radio.dataset.bspOption === 'first' ? this.firstIndex : this.secondIndex;
          radio.checked = radio.value === variant.options[index];
        });
      }

      configurePreview() {
        this.preview = this.querySelector('[data-bsp-preview]');
        this.base = this.querySelector('[data-bsp-base]');
        const paths = [this.config.firstMaskPath, this.config.secondMaskPath];
        this.previewReady = Boolean(this.base && this.config.baseImageUrl && paths.every(path => typeof path === 'string' && /^[Mm][0-9\s.,eE+\-a-df-zA-DF-Z]*$/.test(path.trim())));
        const rasterReady = ['first', 'second'].every(side => Object.keys(this.overlayUrls[side]).length === 12);
        if (!this.previewReady && !rasterReady) {
          this.querySelector('[data-bsp-preview-note]').textContent = this.strings.previewUnavailable;
          this.querySelector('.wtm-bsp__preview-badge').hidden = true;
        }
        if (this.previewReady) this.preview.removeAttribute('hidden');
        this.base?.addEventListener('error', () => {
          this.preview.setAttribute('hidden', '');
          this.previewReady = false;
          ['first', 'second'].forEach(side => {
            this.rasterTokens[side]++;
            this.querySelector(`[data-bsp-raster="${side}"]`).hidden = true;
          });
          this.overlayUrls = { first: {}, second: {} };
          this.querySelector('.wtm-bsp__preview-badge').hidden = true;
          this.querySelector('[data-bsp-preview-note]').textContent = this.strings.previewUnavailable;
          if (this.config.fallbackImageUrl && this.base.src !== this.config.fallbackImageUrl) this.base.src = this.config.fallbackImageUrl;
        }, { once: true, signal: this.controller.signal });
      }

      recolor(side, value) {
        const color = this.colorFor(value);
        const layer = this.querySelector(`[data-bsp-layer="${side}"]`);
        if (!color || !this.previewReady) {
          layer.setAttribute('visibility', 'hidden');
        } else {
          ['r', 'g', 'b'].forEach((channel, index) => {
            const component = parseInt(color.slice(1 + index * 2, 3 + index * 2), 16) / 255;
            const values = [0, component * 0.20, component * 0.55, component, 0.70 + 0.30 * component, 1].map(value => value.toFixed(5)).join(' ');
            this.querySelector(`[data-bsp-channel="${side}-${channel}"]`).setAttribute('tableValues', values);
          });
          layer.setAttribute('visibility', 'visible');
        }
        this.applyRaster(side, value, layer);
      }

      async applyRaster(side, value, layer) {
        const token = ++this.rasterTokens[side];
        const image = this.querySelector(`[data-bsp-raster="${side}"]`);
        const url = this.overlayUrls[side][this.monthFor(value)];
        if (image.dataset.bspUrl === url && !image.hidden) {
          layer.setAttribute('visibility', 'hidden');
          return;
        }
        image.hidden = true;
        if (!url) return;
        try {
          const preload = new Image();
          preload.src = url;
          await preload.decode();
          if (!this.isConnected || this.rasterTokens[side] !== token) return;
          image.src = url;
          image.dataset.bspUrl = url;
          image.hidden = false;
          layer.setAttribute('visibility', 'hidden');
        } catch (_) {}
      }

      failClosed(message) {
        this.validSelection = false;
        this.variantInput.value = '';
        this.variantInput.disabled = true;
        this.syncProperties();
        this.submitButton.disabled = true;
        this.status.textContent = message;
        this.submitText.textContent = this.strings.unavailable || message;
        this.setAttribute('data-bsp-error', '');
      }

      update() {
        if (!this.validCatalog) return;
        const values = ['first', 'second'].map(side => this.querySelector(`[data-bsp-option="${side}"]:checked`)?.value || '');
        ['first', 'second'].forEach((side, index) => {
          this.querySelector(`[data-bsp-summary="${side}"]`).textContent = values[index] || this.strings.notSelected;
          this.recolor(side, values[index]);
        });
        const variant = values.every(Boolean) ? this.catalog.get(JSON.stringify(values)) : null;
        if (!values.every(Boolean)) {
          this.renderPrice(this.config.variants[0]);
          const message = !values[0] && !values[1] ? this.strings.chooseBoth : !values[0] ? this.strings.chooseFirst : this.strings.chooseSecond;
          this.failClosed(message);
          this.submitText.textContent = message;
          this.removeAttribute('data-bsp-error');
          return;
        }
        if (!variant) {
          this.failClosed(this.strings.unavailable);
          return;
        }
        this.renderPrice(variant);
        if (variant.available !== true || variant.requires_selling_plan === true) {
          this.failClosed(this.strings.soldOut);
          this.submitText.textContent = this.strings.soldOut;
          return;
        }
        this.validSelection = true;
        this.variantInput.value = String(variant.id);
        this.variantInput.disabled = false;
        this.syncProperties(values[0], values[1]);
        this.form.elements.quantity.value = '1';
        this.submitButton.disabled = false;
        this.submitText.textContent = this.strings.addToCart;
        this.status.textContent = this.strings.ready;
        this.removeAttribute('data-bsp-error');
      }

      quoteFor(variant) {
        const serverPrice = this.config.prices[String(variant.id)];
        const currency = this.config.presentmentCurrency;
        if (!currency || currency === 'USD' || this.config.shopCurrency !== 'USD') return serverPrice;
        const fx = window.Shopify?.currency;
        const rate = Number(fx?.rate);
        const baseDiscount = Number(this.config.displayDiscountCents);
        if (fx?.active !== currency || !Number.isFinite(rate) || rate <= 0 || !Number.isFinite(baseDiscount) || baseDiscount < 0) return serverPrice;
        let digits;
        try {
          digits = new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
        } catch (_) { return serverPrice; }
        const unit = digits === 0 ? 100 : 1;
        const convertedDiscount = Math.round(baseDiscount * rate / unit) * unit;
        if (!Number.isSafeInteger(convertedDiscount)) return serverPrice;
        const saving = Math.min(variant.price, convertedDiscount);
        const price = variant.price - saving;
        return {
          price: this.formatMoney(price, currency),
          compare: this.formatMoney(variant.price, currency),
          saving: this.formatMoney(saving, currency, true),
          priceAmount: price,
          compareAmount: variant.price,
          savingAmount: saving
        };
      }

      formatMoney(amount, currency, compact = false) {
        const options = { style: 'currency', currency, currencyDisplay: 'narrowSymbol' };
        if (compact && amount % 100 === 0) options.minimumFractionDigits = 0;
        return new Intl.NumberFormat(this.config.locale || 'en', options).format(amount / 100) + ' ' + currency;
      }

      renderPrice(variant) {
        if (!variant) return;
        const price = this.quoteFor(variant);
        this.querySelector('[data-bsp-price]').textContent = this.plainMoney(price.price);
        if (this.submitPrice) this.submitPrice.textContent = this.plainMoney(price.price);
        const compare = this.querySelector('[data-bsp-compare]');
        compare.textContent = this.plainMoney(price.compare);
        compare.hidden = !((price.compareAmount ?? variant.compare_at_price) > (price.priceAmount ?? variant.price));
        if (this.savingBadge) {
          const discounted = price.savingAmount > 0;
          this.savingBadge.hidden = !discounted;
          if (discounted) this.savingBadge.textContent = this.strings.savingTemplate.replace('[amount]', this.plainMoney(price.saving));
        }
      }

      plainMoney(value) {
        const template = document.createElement('template');
        template.innerHTML = String(value || '');
        return template.content.textContent;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
